import {Pipe, PipeTransform} from '@angular/core';
import moment from 'moment';

@Pipe({
  name: 'releaseIsNotPublicPipe'
})
export class ReleaseIsNotPublicPipePipe implements PipeTransform {
  transform(value: string, args?: any): boolean {
    const now = moment().format('YYYY-MM-DD');
    return !value || value.startsWith('3') || value > now;
  }
}
